module.exports = __webpack_public_path__ + "img/01_sub_no.66a1b67e.svg";